import React from "react";

const UserLocation = ({ detectUserLocation, detectingLocation, message }) => {
  return (
    <div className="mb-4">
      <button
        className="w-[200px] bg-blue-500 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded"
        onClick={detectUserLocation}
        disabled={detectingLocation}
      >
        {detectingLocation ? "Locating..." : "Use My Location"}
      </button>
      {message && <p className="mt-2 text-red-500">{message}</p>}
    </div>
  );
};

export default UserLocation;
